import { ImageObject } from '@packages/image/lib/types';
import * as Yup from 'yup';
import { Model, ModelClass } from './Model';
import { useIndex } from './utils/hook-reducers';

export interface CategoryType extends ModelClass {
    id: number;
    name: string;
    slug: string;
    alias: string;
    code: string;
    image_id: number;
    image: ImageObject;
    preview_photo: ImageObject;
    published: boolean;
    hide_from_builder: boolean;
    page_title: string;
    meta_keywords: string;
    meta_description: string;
    description: string;
    sport_id: number;
    bottom_description: string;
}

export const Category = Model<CategoryType>('Category', { endpoint: 'apparel-categories' })`
    id:Int;
    name:String;
    slug:String;
    description:String;
    bottom_description:String;
    alias:String;
    code:String;
    image_id:Int;
    image:Any;
    tags: Any;
    preview_photo:Any;
    published:boolean;
    hide_from_builder:boolean;
    page_title:String;
    meta_keywords:String;
    meta_description:String;
    sport_id:Int;
`;

export const CategoryValidation = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    sport_id: Yup.number().required('Sport is required'),
});
export const useCategoryIndex = (params, options = {}) => {
    const { items, firstLoad, pagination, isLoading, request, isError } = useIndex(Category, params, options);
    return {
        categories: items,
        items,
        firstLoad,
        pagination,
        isLoading,
        isError,
        request,
    };
};
